<template lang="pug">
  .component-reservation-route
    GoogleMapContainer
      GoogleMap(:api-key="mapsAPI", :center="mapCenter", ref="logs", :mapTypeControl="true")
        .allowed(v-for="(allowed) in zones['allowed']")
          google-map-polygon(v-for="poly in allowed.poly", :positions="poly", color="green", fillColor="green")
        .forbidden(v-for="(forbidden) in zones['forbidden']")
          google-map-polygon(v-for="poly in forbidden.poly", :positions="poly", color="red", fillColor="red")
        .undesirable(v-for="(undesirable) in zones['undesirable']")
          google-map-polygon(v-for="poly in undesirable.poly", :positions="poly", color="yellow", fillColor="yellow")
        GoogleMapMarker(v-if="showMarkers", v-for="index in currentPointStep", :label="`${index}`", :title="`${index}`", :position="routes[index-1]", :clickable="true")
          p {{$date(routes[index -1].timestamp).format('DD MMM YYYY HH:mm:ss')}}
        GoogleMapPolyline(:positions="showRoute")


    Slider(v-model="currentPointStep", @input="center", :max="routes.length")

    .player(v-if="routes.length")
      span {{$date(routes[0].timestamp).format('DD MMM YYYY HH:mm:ss')}}
      span {{$date(routes[currentPoint].timestamp).format('DD MMM YYYY HH:mm:ss')}}
      span {{$date(routes[routes.length -1].timestamp).format('DD MMM YYYY HH:mm:ss')}}

    .player
      .buttons.fa.fa-2x(:class="autoPlayClass", @click="togglePlay")
      .buttons.fa.fa-2x.fa-map-marker(@click="showMarkers = !showMarkers", :style="[showMarkers ? {color:'green'}:'']")
</template>

<script>
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import GoogleMap from '../../lib/map/GoogleMap.vue'
  import GoogleMapMarker from '../../lib/map/GoogleMapMarker.vue'
  import GoogleMapPolyline from '../../lib/map/GoogleMapPolyline.vue'
  import Slider from '../../components/structure/ui/Slider'
  import {mapState} from 'vuex'
  import GoogleMapContainer from '../../components/backoffice/GoogleMapContainer'
  import GoogleMapPolygon from "../../lib/map/GoogleMapPolygon";

  export default {
    name: 'ReservationRoute',
    components: {
      GoogleMapContainer,
      Slider,
      GoogleMap,
      GoogleMapMarker,
      GoogleMapPolyline,
      GoogleMapPolygon
    },
    data() {
      return {
        routes: [],
        showMarkers: true,
        currentPointStep: 0,
        autoPlay: false,
        player: null,
        zones: []
      }
    },
    created() {
      KeplerBackofficeSdk.reservations.select(this.item).route((data) => {
        this.routes = data
      })
    },
    mounted() {
      KeplerBackofficeSdk.zones.list.grouped((data) => {
        this.zones = data
      })
    },
    methods: {
      center(value) {
        if (value === 0) {
          return
        }
        this.$refs.logs.pan(this.routes[this.currentPoint])
      },
      togglePlay() {
        this.autoPlay = !this.autoPlay


        if (this.autoPlay === false) {
          clearInterval(this.player)
          return
        }


        if (this.currentPointStep === this.routes.length) {
          this.currentPointStep = 0
        }

        this.player = setInterval(() => {
          this.center()
          this.currentPointStep++

          if (this.currentPointStep === this.routes.length) {
            this.autoPlay = false
            clearInterval(this.player)
          }
        }, 1500)
      },
      formatDate(date) {
        const formatted = this.$date(date).format('DD MMM YYYY~HH:mm:ss')
        return formatted.split('~')
      }
    },
    computed: {
      mapsAPI: function () {
        return window.env.GOOGLE_MAPS_KEY
      },
      showRoute() {
        return this.routes.slice(0, this.currentPointStep)
      },
      autoPlayClass() {
        return this.autoPlay ? 'fa-pause' : 'fa-play'
      },
      currentPoint() {
        return this.currentPointStep === 0 ? 0 : this.currentPointStep - 1
      },
      mapCenter() {
        if (this.item.extra[this.item.booking_mode.toLowerCase()] !== undefined && this.item.extra[this.item.booking_mode.toLowerCase()].position !== undefined) {
          return this.item.extra[this.item.booking_mode.toLowerCase()].pickup.position
        }

        return {
          lat: this.configuration.application.application_default_latitude.default,
          lng: this.configuration.application.application_default_longitude.default,
        }
      },
      ...mapState({
        configuration: state => state.configuration,
      }),
    },
    props: ['item']
  }
</script>

<style lang="sass">
  .component-reservation-route
    .player
      display: flex
      flex-direction: row
      justify-content: space-between
      .buttons
        cursor: pointer
</style>



// WEBPACK FOOTER //
// ReservationRoute.vue?0c82b8c6